// index.tsx
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Lazy-load the main bootstrap file
const LazyBootstrap = React.lazy(() => import('./bootstrap'));

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Suspense>
        <LazyBootstrap />
    </Suspense>
);
